import { useQuery } from '@tanstack/react-query';

import appConfig from 'config';

import { api } from './base';

const getProjectedRequirements = async ({ countryCode, regionCode }) => {
	let apiUrl = appConfig.API_V2_URLS.GLOBAL_PROJECTED_REQUIREMENTS;

	if (countryCode) {
		apiUrl = `${appConfig.API_V2_URLS.COUNTRY_PROJECTED_REQUIREMENTS}${countryCode}/`;
	}

	if (regionCode) {
		apiUrl = `${appConfig.API_V2_URLS.REGION_PROJECTED_REQUIREMENTS}${regionCode}/`;
	}

	return api.get(apiUrl);
};

export const useProjectedRequirements = (
	{ countryCode, regionCode },
	options,
) =>
	useQuery({
		queryFn: () => getProjectedRequirements({ countryCode, regionCode }),
		...options,
	});
